import {
  defineComponent,
  reactive,
  readonly,
  computed,
  onMounted,
} from '@vue/composition-api';
import CommonTableFilter from '@/components/common/common-table-filter.component.vue'; // フィルタ用共通コンポーネント
import { Access, SchoolHeader } from '@/shared/type';
import {
  TableFilterDefs,
  TableFilters,
} from '@/components/common/common-table-filter.component';
import { useTitle } from '@/shared/hooks/useTitle';
import { tableHeaderClass } from '@/constants/masterData/v-data-table';

const listItems = [
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
  {
    name: '茨城高校',
    type: '県立中学・中等教育学校',
    liveDate: '2022/01/01 10:00 〜2022/01/31 23:59',
    status: '公開中',
    count: 1000000,
  },
];

// リアクティブな変数の型定義
export type AccessesState = {
  filterDefs: TableFilterDefs; // フィルタ定義
  filters: TableFilters; // フィルタ情報
  schoolHeaders: SchoolHeader[]; // 学校一覧ヘッダ情報
  isLoading: boolean; // サーバーからデータを取得中か否か
  schoolListItem: Access[]; // 学校一覧情報
  total: number; // 全件数
};

export default defineComponent({
  components: { CommonTableFilter },
  setup() {
    const { setTitle } = useTitle();

    const state = reactive<AccessesState>({
      isLoading: false,
      total: 15,
      filterDefs: {
        // フィルタ定義
        name: { title: '学校名称', types: 'KeyWordPartialMatch', chkItems: [] },
        type: { title: '学校区分', types: 'KeyWordPartialMatch', chkItems: [] },
        liveDate: {
          title: '合格者発表用',
          types: 'KeyWordPartialMatch',
          chkItems: [],
        },
        status: {
          title: '公開状況',
          types: 'KeyWordPartialMatch',
          chkItems: [],
        },
        count: {
          title: 'アクセス数',
          types: 'KeyWordPartialMatch',
          chkItems: [],
        },
      },
      filters: {}, // フィルタ情報
      schoolHeaders: [], // 学校一覧ヘッダ情報
      schoolListItem: [], // 学校一覧情報
    });
    // 学校一覧ヘッダ情報(初期表示ヘッダ)
    const schoolHeaders: SchoolHeader[] = [
      {
        text: '学校名称',
        value: 'name',
        width: '70px',
        class: tableHeaderClass,
      },
      {
        text: '学校区分',
        value: 'type',
        width: '120px',
        class: tableHeaderClass,
      },
      {
        text: '合格者発表日',
        value: 'productionDate',
        width: '60px',
        class: tableHeaderClass,
      },
      {
        text: '公開状況',
        value: 'status',
        width: '70px',
        class: tableHeaderClass,
      },
      // {
      //   text: 'アクセス数',
      //   value: 'count',
      //   width: '120px',
      //   class: tableHeaderClass,
      // },
      // 行アイコン
      {
        text: '',
        value: 'actions',
        sortable: false,
        width: '4%',
        class: tableHeaderClass,
        align: 'end',
      },
    ];

    onMounted(() => {
      setTitle({ title: 'アクセス状況', icon: 'mdi-format-list-bulleted' });

      // 初期表示ヘッダ設定
      state.schoolHeaders = schoolHeaders;

      // 学校一覧情報
      state.schoolListItem = listItems;
    });

    const totalAccesses = computed(() =>
      state.schoolListItem
        .map((item) => item.count)
        .reduce((prev, current) => prev + current, 0),
    );

    return {
      state: readonly(state),
      totalAccesses,
    };
  },
});
